export const getIdEstadoFromNombre = (estado) => {
    const estadosMap = {
        activo: 1,
        inactivo: 2,
        pendiente_activacion: 3
    };

    return estadosMap[estado.toLowerCase()] ?? null;
};

/*export const idEstadosPublicacion = {
    "activo": 1,
    "pausado": 2,
    "pendiente_activacion": 3,
    "en_revision": 4,
    "eliminado": 5
}*/